/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Card_PrevInputs */

const en_us2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous card`)
};

const pt_br2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão anterior`)
};

const es_419_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta anterior`)
};

const pt_pt2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão anterior`)
};

const fr_fr2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte précédente`)
};

const de_de2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Karte`)
};

const it_it2_wrapped_card_prev = /** @type {(inputs: Wrapped_Card_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda precedente`)
};

/**
* | output |
* | --- |
* | "Previous card" |
*
* @param {Wrapped_Card_PrevInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_card_prev = /** @type {((inputs?: Wrapped_Card_PrevInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Card_PrevInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_card_prev(inputs)
	if (locale === "es-419") return es_419_wrapped_card_prev(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_card_prev(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_card_prev(inputs)
	if (locale === "de-DE") return de_de2_wrapped_card_prev(inputs)
	if (locale === "it-IT") return it_it2_wrapped_card_prev(inputs)
	return en_us2_wrapped_card_prev(inputs)
});
export { wrapped_card_prev as "wrapped.card_prev" }